<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'AppMain',
  props: {
    source: {
      type: String,
      default: ''
    }
  }
};
</script>
